import { cloneElement, ComponentPropsWithoutRef } from 'react'
import ChatIcon from '@ui-components-3/icons/lib/duotone/MessageText'
import PhoneIcon from '@ui-components-3/icons/lib/duotone/Phone'
import VideoIcon from '@ui-components-3/icons/lib/duotone/Video'
import type { Merge } from '@ui-components-3/ui/lib/types'

const ICONS_BY_VISIT_MODALITY = {
  video: <VideoIcon aria-label="video visit icon" className="typography-neutral-800" />,
  phone: <PhoneIcon aria-label="phone visit icon" className="typography-neutral-800" />,
  chat: <ChatIcon aria-label="chat visit icon" className="typography-neutral-800" />,
} as const

export type VISIT_MODALITY = keyof typeof ICONS_BY_VISIT_MODALITY

type VisitModalityIconProps = Merge<
  ComponentPropsWithoutRef<'svg'>,
  {
    modality: VISIT_MODALITY
  }
>

const VisitModalityIcon = ({ modality, ...props }: VisitModalityIconProps) =>
  cloneElement(ICONS_BY_VISIT_MODALITY[modality], props)

export default VisitModalityIcon
